var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7957 11.0741C3.25972 6.40058 7.204 2.75 12 2.75C15.371 2.75 18.3221 4.55329 19.9391 7.25H17.0001C16.5858 7.25 16.2501 7.58579 16.2501 8C16.2501 8.41421 16.5858 8.75 17.0001 8.75H21.1515C21.1627 8.75025 21.1739 8.75025 21.1851 8.75H21.4001C22.1456 8.75 22.7501 8.14558 22.7501 7.4V3C22.7501 2.58579 22.4143 2.25 22.0001 2.25C21.5858 2.25 21.2501 2.58579 21.2501 3V6.51989C19.3774 3.36573 15.9365 1.25 12 1.25C6.42529 1.25 1.84247 5.49278 1.30304 10.9259C1.26212 11.3381 1.56308 11.7054 1.97527 11.7463C2.38746 11.7873 2.75478 11.4863 2.7957 11.0741ZM12.0494 21.25C16.8454 21.25 20.7897 17.5994 21.2537 12.9259C21.2946 12.5137 21.662 12.2127 22.0742 12.2537C22.4863 12.2946 22.7873 12.6619 22.7464 13.0741C22.207 18.5072 17.6241 22.75 12.0494 22.75C8.11297 22.75 4.672 20.6343 2.79937 17.4801V21C2.79937 21.4142 2.46359 21.75 2.04937 21.75C1.63516 21.75 1.29937 21.4142 1.29937 21V16.6C1.29937 15.8544 1.90379 15.25 2.64937 15.25H2.86433C2.87555 15.2497 2.88676 15.2497 2.89794 15.25H7.04937C7.46359 15.25 7.79937 15.5858 7.79937 16C7.79937 16.4142 7.46359 16.75 7.04937 16.75H4.11035C5.72734 19.4467 8.67846 21.25 12.0494 21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDouble);
export default __webpack_public_path__ + "static/media/refresh-double.c55cbbb6.svg";
export { ForwardRef as ReactComponent };